import { TimelineEventStatus } from '../models/enums/timeline-event-status.enum';
import { TimelineEvent } from '../models/timeline-event.model';

const MILLISECONDS_PER_HOUR = 60 * 60 * 1000;
const MIN_COMPLETED_EVENT_DURATION_DAYS = 1;
const MILLISECONDS_PER_DAY = 24 * MILLISECONDS_PER_HOUR;

const EASTERN_STANDARD_UTC_OFFSET_HOURS = 5;
const TIMELINE_TRANSITION_HOUR_EASTERN = 3;

export const getProjectedTransitionDate = (
    engagementStartDate: Date | string,
    dayOffset: number
): Date => {
    const start =
        typeof engagementStartDate === 'string'
            ? new Date(engagementStartDate)
            : engagementStartDate;
    const easternStart = new Date(
        start.getTime() -
            EASTERN_STANDARD_UTC_OFFSET_HOURS * MILLISECONDS_PER_HOUR
    );
    return new Date(
        Date.UTC(
            easternStart.getUTCFullYear(),
            easternStart.getUTCMonth(),
            easternStart.getUTCDate() + dayOffset,
            TIMELINE_TRANSITION_HOUR_EASTERN +
                EASTERN_STANDARD_UTC_OFFSET_HOURS
        )
    );
};

const addDays = (base: Date | string, days: number): Date => {
    const baseDate = typeof base === 'string' ? new Date(base) : base;
    return new Date(baseDate.getTime() + days * MILLISECONDS_PER_DAY);
};

const toUtcDayNumber = (value: Date | string): number => {
    const date = typeof value === 'string' ? new Date(value) : value;
    return Math.floor(
        Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()) /
            MILLISECONDS_PER_DAY
    );
};

export const getDayOffset = (
    date: Date | string,
    engagementStartDate: Date | string
): number => {
    return toUtcDayNumber(date) - toUtcDayNumber(engagementStartDate);
};

export const getEventDeadlineDate = (
    engagementStartDate: Date | string,
    event: TimelineEvent
): Date => {
    const effectiveStart = event.startedAt
        ? new Date(event.startedAt)
        : addDays(engagementStartDate, event.dayStart);
    return addDays(effectiveStart, event.currentTempoDurationDays - 1);
};

export const getEventCompletionDate = (event: TimelineEvent): Date | null => {
    return event.completedAt ? new Date(event.completedAt) : null;
};

export const getDisplayedDuration = (event: TimelineEvent): number => {
    const derivedDuration = event.dayEnd - event.dayStart;
    return event.status === TimelineEventStatus.Completed
        ? Math.max(MIN_COMPLETED_EVENT_DURATION_DAYS, derivedDuration)
        : derivedDuration;
};
